"use strict";
exports.getUnixTime = getUnixTime;
var _index = require("./toDate.js");
function getUnixTime(date) {
  return Math.trunc(+(0, _index.toDate)(date) / 1e3);
}
